<template>
  <div>
    <div class="rank-area">
      <div class="rank-item">
        <p class="title">現在のポイント</p>
        <p class="text">
          {{ registrationData.Point }}
        </p>
        <p class="unit">ポイント</p>
      </div>
      <div class="rank-item">
        <p class="title">利用済ポイント</p>
        <p class="text">
          {{ registrationData.TotalPoint - registrationData.Point}}
        </p>
        <p class="unit">ポイント</p>
      </div>
      <div class="rank-item">
        <p class="title">現在の応募可能回数</p>
        <p class="text">{{this.canSendCount}}</p>
        <p class="unit">回</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "show-my-page-data",
  components: {
    ButtonTextLink,
  },
  computed: {
    ...mapState(["registrationData", "isLoggedInWithFirebaseAuth"]),
    selectedMypageSpot() {
      return this.selectedSpotData.mypage;
    },
    canSendCount() {
      return Math.trunc(
        (this.registrationData.Point) / 100,
      );
    },
  },
  methods: {
    ...mapMutations(["setModal"]),
    onClick() {
      this.setModal("signin");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.text {
  text-align: center;
  margin: 4px 0;
}

.rank-area {
  border: #c3c3c3 solid 1px;
  margin: 1rem 0 0;
  display: flex;
  justify-content: space-between;
  border-radius: 20px;
  background: #fff;
  box-shadow: 2px 2px 2px 0px rgba(1, 39, 76, 0.2);
  padding: 1rem 0;
  .rank-item {
    width: 100%;
    text-align: center;
    p {
      margin: 0;
    }
    .title {
      color: #848a94;
      font-size: 0.75rem;
      margin-bottom: 0.25rem;
    }
    .text {
      color: #242529;
      font-weight: bold;
      margin-bottom: 0.25rem;
    }
    .unit {
      color: #848a94;
      font-size: 0.75rem;
    }
    &:not(:last-child) {
      border-right: 1px solid #e0e0e0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyPage/PresentMyData.vue